module.exports = __webpack_public_path__ + "static/media/grapefruit-3.a3bc5a21.png";